// extracted by css-extract-rspack-plugin
export default {"cls1":"FullScreenPremiumModal-cls1_-_I","cls2":"FullScreenPremiumModal-cls2_L80 FullScreenPremiumModal-cls1_-_I"};